
/**
 * Retorna el input si todo está ok, sino devuelve la fecha pasada como parámetro.
 */
String.prototype.ValidDate = function (result) {
    //TODO: Ver caso cuando en el mes se envía sólo 1 dígito. En tal caso, agregarle 1 cero
    //TODO: también chequear fecha válidas. Por ej, no permitir 31/04/2022 o 30/02/2022
    try {
        if (this.length != 10) return result;
        if (this.substring(2, 3) != "/") return result;
        if (this.substring(5, 6) != "/") return result;

        var days = parseInt(this.substring(0, 2));
        var months = parseInt(this.substring(3, 5));
        var years = parseInt(this.substring(6, 10));

        if(!(days > 0 && days <= 31)) return result;
        if(!(months > 0 && months <= 12)) return result;
        if(!(years > 1800 && years <= 3000)) return result;

        return this;
    } catch (e) {
        console.log(e);
        return result;
    }
};
